import {format, parseISO} from 'date-fns'





const formatLocalString = (datetime:string) => {
    if (!datetime) return '';
    const date = parseISO(datetime)
    const local_datetime = format(date,"yyyy-MM-dd'T'HH:mm:ss")
    return local_datetime;
}

const formatUTCString = (datetime:string|null|undefined) => {
    
    if (!datetime) return '';
    const utc_datetime = new Date(datetime).toISOString();
   
    return utc_datetime;
}

export {formatLocalString, formatUTCString}
